var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEdge = function SvgEdge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#edge_svg__a)",
    d: "M14.694 11.905c0-2.005-2.083-5.465-6.777-5.465-4.693 0-6.417 3.913-6.417 5.584C1.5 6.058 6.36 1.5 12.132 1.5c5.77 0 10.368 4.32 10.368 8.71 0 3.914-2.945 5.274-5.34 5.274-1.58 0-3.376-.525-3.376-1.36 0-.645.91-.645.91-2.22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#edge_svg__b)",
    d: "M7.917 6.44c4.694 0 6.777 3.46 6.777 5.464v.046c-.024-1.334-.925-2.6-2.706-2.6-2.25 0-5.292 3.055-4.885 6.85.326 3.037 2.898 7.111 8.477 5.68 0 0-1.054.62-3.999.62C6.361 22.5 1.5 17.727 1.5 12.262q0-.217.007-.426c.12-1.758 1.885-5.397 6.41-5.397"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#edge_svg__c)",
    d: "M7.917 6.44c4.694 0 6.777 3.46 6.777 5.464v.046c-.024-1.334-.925-2.6-2.706-2.6-2.25 0-5.292 3.055-4.885 6.85.326 3.037 2.898 7.111 8.477 5.68 0 0-1.054.62-3.999.62C6.361 22.5 1.5 17.727 1.5 12.262q0-.217.007-.426c.12-1.758 1.885-5.397 6.41-5.397"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0E458A",
    d: "M14.93 22.125c2.99-.815 5.125-3.36 5.51-3.872.432-.573.551-.931.432-1.05-.12-.12-.288-.096-.719.119-.43.215-2.969 1.265-5.866.382C11.389 16.82 9.402 14.53 9.402 12c0-1.956 1.676-2.648 2.586-2.648-2.25 0-5.292 3.054-4.885 6.848.326 3.038 2.898 7.112 8.477 5.68 0 0-.195.114-.65.245"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#edge_svg__d)",
    d: "M14.93 22.125c2.99-.815 5.125-3.36 5.51-3.872.432-.573.551-.931.432-1.05-.12-.12-.288-.096-.719.119-.43.215-2.969 1.265-5.866.382C11.389 16.82 9.402 14.53 9.402 12c0-1.956 1.676-2.648 2.586-2.648-2.25 0-5.292 3.054-4.885 6.848.326 3.038 2.898 7.112 8.477 5.68 0 0-.195.114-.65.245"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "edge_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(59.214 -8.43 14.34)scale(7.11114 7.12274)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1284D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.814,
    stopColor: "#1170B2",
    stopOpacity: 0.768
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E649B",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "edge_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(1.19726 5.63181 -6.0803 1.2926 14 16.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#104890"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#12529E",
    stopOpacity: 0.706
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4584",
    stopOpacity: 0.58
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edge_svg__a",
    x1: 21.279,
    x2: 0.741,
    y1: 13.909,
    y2: 9.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BCC50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#2ABAD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DCFE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edge_svg__b",
    x1: 8.54,
    x2: 8.54,
    y1: 6.439,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#035989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#1175B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0470CF"
  })))));
};
export default SvgEdge;